import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import { getQaSelectorButton } from '../../../utils/common'
import { FloatingTooltip } from '../../Floating'
import { IconNG } from '../../Icon'
import { LoaderText } from '../../LoaderText'
import Text from '../../Text'

import { QA_NAME_GENERATE_SUMMARY_BUTTON } from './ProfileAISummaryWidgetLoadButton.constants'

import * as styles from './ProfileAISummaryWidgetLoadButton.module.css'

import SpinnerIcon from '../../../icons/spinner/spinner-ai-dark.svg'
import StarIcon from '../../../icons/unique/ai/star-3.svg'

function ProfileAISummaryWidgetLoadButton({
  className = styles.ProfileAISummaryWidgetLoadButton,
  loading,
  text,
  tooltip,
  onClick,
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const qaProps = getQaSelectorButton({
    value: QA_NAME_GENERATE_SUMMARY_BUTTON,
  })

  return (
    <div {...qaProps} className={className} onClick={onClick}>
      {loading ? (
        <LoaderText
          className={styles.loader}
          iconProps={{ Icon: SpinnerIcon }}
          textProps={{ className: styles.loaderText, isSecondary: false }}
        />
      ) : (
        <>
          <IconNG Icon={StarIcon} />
          <FloatingTooltip
            content={tooltip}
            disabled={!overflow}
            placement={FLOATING_ELEMENT_PLACEMENT.top}
          >
            <Text className={styles.text} ref={setContentOverflowRef}>
              {text}
            </Text>
          </FloatingTooltip>
        </>
      )}
    </div>
  )
}

export default ProfileAISummaryWidgetLoadButton
